<template>
  <el-container class="main_container">
    <base-header>
      <el-button @click="dialogVisible = true" type="primary"
        >新增管理员</el-button
      >
    </base-header>
    <el-main>
      <el-table :data="manager_list" style="width: 100%" height="100%">
        <el-table-column fixed prop="date" label="微信头像和昵称" width="150">
          <template v-slot="scope">
            <div>
              <img
                class="avatar-img"
                v-if="scope.row.avatar_url"
                :src="scope.row.avatar_url"
              />
              {{ scope.row.nickname }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="120">
        </el-table-column>
        <el-table-column label="添加时间" width="200">
          <template v-slot="scope">
            <div>
              {{ scope.row.create_time }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <!-- <el-popover placement="top" width="160" v-model="scope.row.visible">
              <p>确定删除此管理员吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button
                  type="text"
                  size="mini"
                  @click="scope.row.visible = false"
                  >取消</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="removeManager(scope.row)"
                  >确定</el-button
                >
              </div>
              <el-button type="danger" slot="reference">移除管理员</el-button>
            </el-popover> -->
            <el-popconfirm
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon="el-icon-info"
              icon-color="red"
              title="确定删除此管理员吗？"
              @onConfirm="removeManager(scope.row)"
              @confirm="removeManager(scope.row)"
            >
              <el-button type="danger" slot="reference">移除管理员</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer">
      <el-pagination
        :total="totalCount"
        :page-size="pagesize"
        :current-page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </el-footer>
    <dialog-modal :show.sync="dialogVisible" @getList="getList" />
  </el-container>
</template>

<script>
import DialogModal from "./components/DialogModal";
import pageMixin from "../../../mixins/page";
import getTokenMixin from "../../../mixins/getToken";
export default {
  components: { DialogModal },
  mixins: [pageMixin, getTokenMixin],
  data() {
    return {
      dialogVisible: false,
      ManagerListURL: this.getDomain() + "bmpopularize/get_manager_list",
      DeletePopularizeManagerURL:
        this.getDomain() + "bmpopularize/delete_popularize_manager",
      manager_list: [],
    };
  },
  methods: {
    getList() {
      let params = {
        page: this.page,
        pagesize: this.pagesize,
      };
      let handle = (res) => {
        this.totalCount = res.data.content.total_count;
        this.manager_list = res.data.content.manager_list;
        this.manager_list.forEach((item) => {
          item.create_time = this.timeTransform(item.create_time);
        });
      };
      this.__axios(this.ManagerListURL, params, handle);
    },

    removeManager(row) {
      let params = {
        username: row.username,
      };
      let handle = (res) => {
        this.$message.success("删除成功");
        this.getList();
      };
      this.__axios(this.DeletePopularizeManagerURL, params, handle);
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style scoped>
.avatar-img {
  width: 40px;
  height: 40px;
  vertical-align: middle;
}
</style>
